export const MAX_POST_LENGTH = 1000;
export const MAX_COMMENT_LENGTH = 1000;
export const MAX_TITLE_LENGTH = 140;

export const PREVIEW_NEEDED_LENGTH = 240;
export const SYMBOLS_COUNTER_NEEDED_LENGTH = {
  POST: 950,
  COMMENT: 950,
  TITLE: 90,
};

export const MAX_IMAGES_COUNT = 10;
export const MAX_IMAGE_SIZE_MB = 5;
export const MAX_DOCUMENT_SIZE_MB = 25;
export const SUPPORTED_DOCUMENT_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
];
export const SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/png'];